import { Suspense } from "react";
import { LoadingIndicator, Footer } from "components";
import { ErrorBoundary } from "components/ErrorBoundary/ErrorBoundary";
import { Outlet, useLocation } from "react-router-dom";

const FOOTER_SEGMENTS: string[] = [
  "overview",
  "holdings",
  "transactions",
  "documents",
];

export const MainLayout = () => {
  const { pathname } = useLocation();

  // e.g.
  // "/"                                  -> []
  // "/overview"                          -> ["overview"]
  // "/holdings/123"                      -> ["holdings", "123"]
  // "/portfolio/42/overview"             -> ["portfolio", "42", "overview"]
  // "/impersonate/5/transactions/999"    -> ["impersonate", "5", "transactions", "999"]
  const segments = pathname.split("/").filter(Boolean);

  const shouldShowFooter = segments.some((segment) =>
    FOOTER_SEGMENTS.includes(segment)
  );

  return (
    <div className="box-border text-gray-900 bg-gray-50 h-[calc(100vh-0.5rem)] flex flex-col">
      <div className="flex-1 min-h-0 overflow-y-auto">
        <ErrorBoundary>
          <Suspense fallback={<LoadingIndicator center />}>
            <Outlet />
          </Suspense>
        </ErrorBoundary>
      </div>
      {shouldShowFooter && <Footer />}
    </div>
  );
};